import { render, staticRenderFns } from "./PTabMenu.vue?vue&type=template&id=3279358d&scoped=true&"
import script from "./PTabMenu.vue?vue&type=script&lang=js&"
export * from "./PTabMenu.vue?vue&type=script&lang=js&"
import style0 from "./PTabMenu.vue?vue&type=style&index=0&id=3279358d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279358d",
  null
  
)

export default component.exports